module.exports = __webpack_public_path__ + "img/page-2_img04.74bdc7bc.jpg";